document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('sku-search')
  const clearButton = document.getElementById('clear-search')
  const cards = document.querySelectorAll('.ingredient-card')
  const productBanner = document.getElementById('selected-product-banner')
  const productImage = document.getElementById('selected-product-image')
  const productTitle = document.getElementById('selected-product-title')
  const productDescription = document.getElementById('selected-product-description')
  const productMetaContainer = document.getElementById('selected-product-meta')
  const productLastUpdated = document.getElementById('selected-product-last-updated')
  const productAllergens = document.getElementById('selected-product-allergens')
  const noResultsBanner = document.getElementById('no-results-banner')

  // Build product dictionary from hidden DOM elements.
  const productDataElements = document.querySelectorAll('#product-data div')
  const productDict = {}

  productDataElements.forEach(el => {
    const sku = el.getAttribute('data-sku')
    if (sku && !productDict[sku]) {
      productDict[sku] = {
        title: el.getAttribute('data-title'),
        image: el.getAttribute('data-image'),
        description: el.getAttribute('data-description'),
        lastUpdated: el.getAttribute('data-last-updated'),
        allergens: el.getAttribute('data-allergens')
      }
    }
  })

  function filterIngredients(sku) {
    sku = sku.trim().toUpperCase()

    // Toggle clear button
    if (sku.length > 0) {
      clearButton.classList.remove('hidden')
    } else {
      clearButton.classList.add('hidden')
    }

    if (sku === '') {
      // Reset view
      cards.forEach(card => {
        card.style.display = 'flex'
        // Force reflow
        void card.offsetWidth
        card.style.opacity = '1'
        card.style.transform = 'scale(1)'
      })
      hideBanner()
      noResultsBanner.classList.add('hidden')
      return
    }

    let visibleCount = 0

    // Filter cards
    cards.forEach(card => {
      const cardSkusStr = card.getAttribute('data-skus')
      const cardSkus = cardSkusStr
        ? cardSkusStr
            .toUpperCase()
            .split(',')
            .map(s => s.trim())
        : []

      const isMatch = cardSkus.some(cardSku => cardSku === sku || cardSku.startsWith(sku))

      if (isMatch) {
        card.style.display = 'flex'
        // Force reflow
        void card.offsetWidth
        card.style.opacity = '1'
        card.style.transform = 'scale(1)'
        visibleCount++
      } else {
        card.style.opacity = '0'
        card.style.transform = 'scale(0.95)'
        setTimeout(() => {
          if (card.style.opacity === '0') {
            card.style.display = 'none'
          }
        }, 300) // Wait for transition
      }
    })

    // Handle product banner based on exact match (or close enough)
    // Try exact object lookup first
    let matchingProduct = productDict[sku]

    // If not exact, maybe starts with? Only if they type enough chars for it to make sense
    if (!matchingProduct && sku.length > 3) {
      const possibleSku = Object.keys(productDict).find(k => k.startsWith(sku))
      if (possibleSku) {
        matchingProduct = productDict[possibleSku]
      }
    }

    if (matchingProduct) {
      showBanner(matchingProduct)
    } else {
      hideBanner()
    }

    if (visibleCount === 0 && sku.length > 2) {
      setTimeout(() => {
        if (searchInput.value.trim().length > 0) {
          noResultsBanner.classList.remove('hidden')
        }
      }, 300)
    } else {
      noResultsBanner.classList.add('hidden')
    }
  }

  function showBanner(product) {
    productTitle.textContent = product.title

    if (product.description && product.description.trim() !== '') {
      productDescription.textContent = product.description
      productDescription.classList.remove('hidden')
    } else {
      productDescription.classList.add('hidden')
    }

    if (product.image && product.image.trim() !== '') {
      productImage.src = product.image
      productImage.classList.remove('hidden')
      productImage.parentElement.classList.remove('bg-gray/5')
      productImage.parentElement.classList.add('bg-white')
    } else {
      productImage.classList.add('hidden')
      productImage.parentElement.classList.add('bg-gray/5')
      productImage.parentElement.classList.remove('bg-white')
    }

    let hasMeta = false

    if (product.lastUpdated && product.lastUpdated.trim() !== '') {
      productLastUpdated.querySelector('.value').textContent = product.lastUpdated
      productLastUpdated.classList.remove('hidden')
      hasMeta = true
    } else {
      productLastUpdated.classList.add('hidden')
    }

    if (product.allergens && product.allergens.trim() !== '') {
      productAllergens.querySelector('.value').textContent = product.allergens
      productAllergens.classList.remove('hidden')
      hasMeta = true
    } else {
      productAllergens.classList.add('hidden')
    }

    if (hasMeta) {
      productMetaContainer.classList.remove('hidden')
      productMetaContainer.classList.add('flex')
    } else {
      productMetaContainer.classList.add('hidden')
      productMetaContainer.classList.remove('flex')
    }

    productBanner.classList.remove('hidden')
    productBanner.classList.add('flex')
    // Force reflow
    void productBanner.offsetWidth
    productBanner.classList.add('show-banner')
    productBanner.classList.remove('opacity-0', 'translate-y-4')
  }

  function hideBanner() {
    productBanner.classList.remove('show-banner')
    productBanner.classList.add('opacity-0', 'translate-y-4')
    setTimeout(() => {
      if (productBanner.classList.contains('opacity-0')) {
        productBanner.classList.add('hidden')
        productBanner.classList.remove('flex')
      }
    }, 300)
  }

  // Debounce function
  function debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  const debouncedFilter = debounce(val => filterIngredients(val), 300)

  searchInput.addEventListener('input', e => {
    debouncedFilter(e.target.value)
  })

  clearButton.addEventListener('click', () => {
    searchInput.value = ''
    filterIngredients('')
    searchInput.focus()
  })

  // Handle accordion custom animation via details
  const accordions = document.querySelectorAll('.ingredient-details')
  accordions.forEach(acc => {
    acc.addEventListener('click', e => {
      if (e.target.closest('summary')) {
        e.preventDefault()

        if (acc.hasAttribute('open')) {
          acc.removeAttribute('open')
        } else {
          // Close others
          accordions.forEach(otherAcc => {
            if (otherAcc !== acc && otherAcc.hasAttribute('open')) {
              otherAcc.removeAttribute('open')
            }
          })
          acc.setAttribute('open', '')
        }
      }
    })
  })
})
